<avd-code-example-header
    [packageName]="packageName"
    [getStartedLink]="getStartedLink"
    [storybookLink]="storybookLink"
    [repoLink]="repoLink"
></avd-code-example-header>

@for (example of examples; track example.variant) {
    <avd-code-example
        [label]="example.label"
        [description]="example.description"
        [htmlSnippet]="example.htmlSnippet"
        [storybookLink]="example.storybookLink"
    >
        @if (example.variant === 'determinate-bar') {
            <div class="avd-progress-indicators-examples__bar-preview">
                <uilab-mat-progress-bar
                    [mode]="example.mode"
                    [value]="example.value"
                ></uilab-mat-progress-bar>
            </div>
        } @else {
            <uilab-mat-progress-spinner
                [mode]="example.mode"
                [diameter]="example.diameter"
            ></uilab-mat-progress-spinner>
        }
    </avd-code-example>
}
